module.exports = "<p-editor [(ngModel)]=\"product.nutrition\" [style]=\"{'min-height':'150px'}\">\n    <p-header>\n        <span class=\"ql-formats\">\n            <button class=\"ql-bold\" aria-label=\"Bold\"></button>\n        </span>\n    </p-header>\n</p-editor>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/products/product-nutrition-form/product-nutrition-form.component.html
// module id = ./src/app/components/forms/products/product-nutrition-form/product-nutrition-form.component.html
// module chunks = main